<template>

    <main>
<!--        <van-nav-bar-->
<!--            :title="title"-->
<!--            left-text=""-->
<!--            left-arrow-->
<!--            @click-left="onClickLeft"-->
<!--        />-->
        <video-player
            :src="videoSrc"
            :options="playerOptions"
            :volume="0.6"
        />
    </main>
</template>

<script setup>
import {ref} from 'vue';
import { VideoPlayer } from '@videojs-player/vue'
import 'video.js/dist/video-js.css'
// 视频链接地址
const videoSrc = ref('https://ayz-prod.oss-cn-shanghai.aliyuncs.com/yaoqingma.mp4');

// const title = ref('兼职红娘邀请码系统介绍');

// 视频播放器配置
let playerOptions = ref({
    width: "100%", //播放器宽度
    playbackRates: [1.0, 1.5, 2.0], // 播放速度
    autoplay: 'any', // 如果true,浏览器准备好时开始回放。
    muted: false, // 默认情况下将会消除任何音频。
    // loop: true, // 导致视频一结束就重新开始。
    // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
    language: 'zh-CN',
    aspectRatio: '3:6', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
    controls: true,
    poster: "https://ayz-prod.oss-cn-shanghai.aliyuncs.com/yqm-cover.jpg", // 设置封面地址
    controlBar: {
        timeDivider: true,
        durationDisplay: true,
        remainingTimeDisplay: false,
        fullscreenToggle: true // 全屏按钮
    }
})

// const onClickLeft = () => history.back();

</script>

<style>
.video-js .vjs-big-play-button {
    top: 45%;
    left: 45%;
    font-size: 2em;
    line-height: 2em;
    height: 2em;
    width: 2em;
    border-radius: 50%;
}

</style>